document.addEventListener("DOMContentLoaded", function () {
  // const isSolutionsPage = window.location.pathname.includes("/solutions");
  // const isProductDetailPage = window.location.pathname.includes("/pages/discover/");
  // const pageTitle = document.querySelector(".page-title");

  const navbar = document.querySelector("header .navbar");
  const secondNavbar = document.querySelector(".second-navbar");

  const languageBtnMobile = document.querySelector(".language-btn");
  const translationDropdownMobile = document.querySelector(
    ".translation-dropdown-mobile",
  );
  const languageDropdownBtnDesktop = document.querySelector(
    ".language-dropdown-desktop button",
  );
  const translationDropdownDesktop = document.querySelector(
    ".translation-dropdown-desktop",
  );
  const countryDropdownDesktop = document.querySelector(
    ".country-dropdown-desktop",
  );

  const slideMenu = document.querySelector(".slide-menu");
  const flyoutMobile = document.querySelector(".flyout-menu.flyout-mobile");
  const flyoutDesktop = document.querySelector(".flyout-menu.flyout-desktop");
  const mobileLeftArrow = document.querySelector(".mobile-left-arrow");
  const hamburger = document.querySelector(".navbar .hamburger");
  const menuCloseButton = document.querySelector(".menu-close");

  const mobileChildGroups = document.querySelectorAll(
    ".flyout-menu.flyout-mobile .child-group",
  );
  const desktopChildGroups = document.querySelectorAll(
    ".flyout-menu.flyout-desktop .child-group",
  );

  const regionButtons = document.querySelectorAll(".region-btn");
  const regionDropdowns = document.querySelectorAll(
    ".country-dropdown-desktop, .custom-region-dropdown .slide-menu-country-dropdown",
  );
  const footerSelect = document.querySelector(".thb-region-select");

  const disableScroll = () => (document.body.style.overflow = "hidden");
  const enableScroll = () => (document.body.style.overflow = "");
  const isMobile = () => window.matchMedia("(max-width: 959px)").matches;

  let flyoutTimeout = null;

  // Close all menus
  function closeMenu() {
    hamburger?.classList.remove("active");
    slideMenu?.classList.remove("active");
    document.body.classList.remove("menu-active");
    enableScroll();

    flyoutMobile?.classList.remove("show", "slide-out");
    flyoutDesktop?.classList.remove("show");

    mobileChildGroups.forEach((g) => (g.style.display = "none"));
    desktopChildGroups.forEach((g) => (g.style.display = "none"));
  }

  // Hamburger toggle (slide-menu only)
  hamburger?.addEventListener("click", () => {
    if (hamburger.classList.contains("active")) closeMenu();
    else {
      hamburger.classList.add("active");
      slideMenu?.classList.add("active");
      document.body.classList.add("menu-active");
      disableScroll();
    }
  });

  menuCloseButton?.addEventListener("click", closeMenu);

  // Outside click to close menus
  document.addEventListener("click", (e) => {
    const target = e.target;
    const isInsideMenu =
      slideMenu?.contains(target) ||
      flyoutMobile?.contains(target) ||
      flyoutDesktop?.contains(target);
    const isInsideDropdown =
      translationDropdownMobile?.contains(target) ||
      translationDropdownDesktop?.contains(target);
    const isTrigger =
      languageBtnMobile?.contains(target) ||
      languageDropdownBtnDesktop?.contains(target);
    const isParentOrHamburger =
      target.closest(".parent-link") || target.closest(".hamburger");

    if (
      !isInsideMenu &&
      !isInsideDropdown &&
      !isTrigger &&
      !isParentOrHamburger
    ) {
      closeMenu();
      translationDropdownMobile?.classList.remove("show");
      translationDropdownDesktop?.classList.remove("show");
    }
  });

  // Language dropdowns
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".language-btn");
    if (!btn) return;
    e.stopPropagation();
    translationDropdownMobile?.classList.toggle("show");
  });

  languageDropdownBtnDesktop?.addEventListener("click", (e) => {
    e.preventDefault();
    translationDropdownDesktop?.classList.toggle("show");
  });

  // Flyout handling
  document.querySelectorAll(".primary-drawer li").forEach((li) => {
    const link = li.querySelector(".parent-link");
    if (!link) return;

    const index = link.getAttribute("data-index");
    const activeMobileGroup = document.querySelector(
      `.flyout-menu.flyout-mobile .child-group[data-index="${index}"]`,
    );
    const activeDesktopGroup = document.querySelector(
      `.flyout-menu.flyout-desktop .child-group[data-index="${index}"]`,
    );

    // Mobile: click to slide-in flyout
    li.addEventListener("click", (e) => {
      if (!isMobile()) return;

      if (!activeMobileGroup || activeMobileGroup.children.length === 0) {
        return;
      }

      e.preventDefault();

      mobileChildGroups.forEach((g) => (g.style.display = "none"));
      activeMobileGroup.style.display = "block";
      flyoutMobile?.classList.add("show");
    });

    // Desktop: hover to show flyout
    link.addEventListener("mouseenter", () => {
      if (isMobile()) return;
      if (flyoutTimeout) clearTimeout(flyoutTimeout);

      desktopChildGroups.forEach((g) => (g.style.display = "none"));
      flyoutDesktop?.classList.remove("show");

      if (activeDesktopGroup && activeDesktopGroup.children.length > 0) {
        flyoutTimeout = setTimeout(() => {
          activeDesktopGroup.style.display = "block";
          flyoutDesktop?.classList.add("show");
        }, 200);
      } else {
        flyoutDesktop?.classList.remove("show");
      }
    });

    // Prevent navigation if desktop group exists
    link.addEventListener("click", (e) => {
      if (
        !isMobile() &&
        activeDesktopGroup &&
        activeDesktopGroup.children.length > 0
      )
        e.preventDefault();
    });
  });

  // Desktop: mouse leave closes flyout
  flyoutDesktop?.addEventListener("mouseleave", () => {
    flyoutDesktop.classList.remove("show");
    desktopChildGroups.forEach((g) => (g.style.display = "none"));
  });

  const primaryDrawer = document.querySelector(".primary-drawer");

  function closeMobileFlyout() {
    flyoutMobile?.classList.remove("show");
    mobileChildGroups.forEach((g) => (g.style.display = "none"));

    if (!slideMenu.classList.contains("active")) {
      document.body.classList.remove("menu-active");
    }
  }

  // Mobile: left arrow closes flyout
  mobileLeftArrow?.addEventListener("click", closeMobileFlyout);

  primaryDrawer?.addEventListener("click", (e) => {
    if (!e.target.closest(".parent-link")) {
      closeMobileFlyout();
    }
  });

  // Page title update
  // if (pageTitle) {
  //   const titleSpan = pageTitle.querySelector("span");
  //   if (isProductDetailPage) titleSpan.textContent = "Products";
  //   else if (isSolutionsPage) titleSpan.textContent = "Solutions";
  // }

  // Sticky navbar
  if (!navbar) return;

  let lastScrollY = window.scrollY;
  let scrollTimeout;
  let isUserScrolling = false;
  const SCROLL_THRESHOLD = 30;

  function showNavbar(reason = "") {
    navbar.classList.remove("hide-navbar");
    secondNavbar?.classList.remove("hide-second-navbar");

    if (window.scrollY > 0) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  }

  function hideNavbar(reason = "") {
    navbar.classList.add("hide-navbar");
    secondNavbar?.classList.add("hide-second-navbar");

    if (window.scrollY > 0) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
  }

  window.addEventListener("wheel", () => (isUserScrolling = true), {
    passive: true,
  });
  window.addEventListener("touchmove", () => (isUserScrolling = true), {
    passive: true,
  });

  window.addEventListener("keydown", (e) => {
    const keysThatScroll = [
      "Home",
      "End",
      "PageUp",
      "PageDown",
      "ArrowUp",
      "ArrowDown",
      " ",
    ];
    if (keysThatScroll.includes(e.key)) {
      isUserScrolling = true;

      setTimeout(() => handleScroll(), 50);
    }
  });

  function handleScroll() {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;

    if (currentScrollY <= 0) {
      showNavbar("at top");
      lastScrollY = currentScrollY;
      return;
    }

    if (!isUserScrolling) return;

    if (Math.abs(delta) > SCROLL_THRESHOLD) {
      if (delta > 0) {
        hideNavbar("scrolling down");
      } else {
        showNavbar("scrolling up");
      }
      lastScrollY = currentScrollY;
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      showNavbar("scroll stopped");
      isUserScrolling = false;
    }, 300);
  }

  window.addEventListener("scroll", handleScroll, { passive: true });

  showNavbar();

  // Resize handler
  window.addEventListener("resize", () => {
    if (isMobile()) {
      flyoutDesktop?.classList.remove("show");
      desktopChildGroups.forEach((g) => (g.style.display = "none"));
      translationDropdownDesktop?.classList.remove("show");
      countryDropdownDesktop?.classList.remove("show");
    } else {
      flyoutMobile?.classList.remove("show");
      mobileChildGroups.forEach((g) => (g.style.display = "none"));
      translationDropdownMobile?.classList.remove("show");
      alignDesktopDropdowns();
    }
  });

  if (!regionButtons.length && !regionDropdowns.length) return;

  let selectedRegion =
    regionButtons[0]?.querySelector("span.text")?.textContent || "US";

  function updateAllRegions(regionCode, regionName) {
    regionButtons.forEach((btn) => {
      const textSpan = btn.querySelector("span.text");
      if (textSpan) {
        textSpan.textContent = regionName;
      } else {
        btn.innerHTML = `<span class="text">${regionName}</span>`;
      }
      btn.title = regionName;
    });

    regionDropdowns.forEach((dropdown) => {
      dropdown.querySelectorAll("[data-region]").forEach((btn) => {
        btn.classList.toggle("active", btn.dataset.region === regionCode);
      });
    });
  }

  const initialBtn = document.querySelector(
    `[data-region="${selectedRegion}"]`,
  );

  if (initialBtn) {
    updateAllRegions(selectedRegion, initialBtn.dataset.regionName);
  }

  function redirectWithSwitchingParam(target) {
    if (!target) return;

    let targetUrl = "";
    if (target.tagName === "OPTION" || target.tagName === "SELECT") {
      targetUrl = target.value || target.options[target.selectedIndex]?.value;
    } else {
      targetUrl = target.getAttribute("href") || target.dataset.url;
    }

    if (!targetUrl) return;

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const attrs = cart.attributes || {};
        const url = new URL(targetUrl, window.location.origin);

        url.searchParams.set("switching_country", "true");

        if (attrs.lead_source === "Affiliate Program") {
          url.searchParams.set("lead_source", attrs.lead_source);
          if (attrs.affid && attrs.oid) {
            url.searchParams.set("affid", attrs.affid);
            url.searchParams.set("oid", attrs.oid);
          } else if (attrs._ef_transaction_id) {
            url.searchParams.set("_ef_transaction_id", attrs._ef_transaction_id);
          }
        } else if (attrs.lead_source === "Replicated Site") {
          url.searchParams.set("lead_source", attrs.lead_source);
          if (attrs._rsu) url.searchParams.set("rsu", attrs._rsu);
        }

        window.location.href = url.toString();
      })
      .catch(() => {
        window.location.href = targetUrl;
      });
  }

  regionButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();

      translationDropdownDesktop?.classList.remove("show");

      let dropdown = btn
        .closest(".custom-region-dropdown")
        ?.querySelector(
          ".country-dropdown-desktop, .slide-menu-country-dropdown",
        );

      if (!dropdown) {
        dropdown = document.querySelector(
          ".country-dropdown-desktop, .slide-menu-country-dropdown",
        );
      }

      const isOpen = dropdown?.classList.contains("show");

      regionDropdowns.forEach((d) => {
        if (d !== dropdown) d.classList.remove("show");
      });

      if (isOpen) {
        dropdown?.classList.remove("show");
      } else {
        dropdown?.classList.add("show");
      }
    });
  });

  document.addEventListener(
    "click",
    function (e) {
      const activeRegionLink = e.target.closest("[data-region].active");
      if (!activeRegionLink) return;

      e.preventDefault();
      e.stopImmediatePropagation();
    },
    true,
  );

  regionDropdowns.forEach((dropdown) => {
    dropdown.querySelectorAll("[data-region]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (btn.classList.contains("active")) return;

        e.preventDefault();
        e.stopPropagation();

        const regionCode = btn.dataset.region;
        const regionName = btn.dataset.regionName;

        selectedRegion = regionCode;
        updateAllRegions(regionCode, regionName);

        syncFooterSelect(regionName);

        regionDropdowns.forEach((d) => d.classList.remove("show"));
        redirectWithSwitchingParam(btn);
      });
    });
  });

  document.addEventListener("click", (e) => {
    const clickedInside = e.target.closest(".custom-region-dropdown");
    if (!clickedInside) {
      regionDropdowns.forEach((d) => d.classList.remove("show"));
    }
  });

  if (footerSelect) {
    function syncFooterSelect(regionName) {
      Array.from(footerSelect.options).forEach((opt) => {
        opt.selected =
          opt.textContent.trim() === regionName ||
          opt.value.toUpperCase() === selectedRegion;
      });
    }

    footerSelect.addEventListener("change", (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const regionName = selectedOption.textContent.trim();

      selectedRegion = selectedOption.value.toUpperCase();
      updateAllRegions(selectedRegion, regionName);

      redirectWithSwitchingParam(selectedOption);
    });

    window.addEventListener("pageshow", (event) => {
      syncFooterSelect(selectedRegion);
    });
  }

  function alignDesktopDropdowns() {
    if (!navbar) return;

    const navbarRect = navbar.getBoundingClientRect();

    const regionBtnDesktop = regionButtons[0];
    if (regionBtnDesktop && countryDropdownDesktop) {
      const btnRect = regionBtnDesktop.getBoundingClientRect();
      const dropdownWidth = countryDropdownDesktop.offsetWidth;
      const centerX =
        btnRect.left + btnRect.width / 2 - dropdownWidth / 2 - navbarRect.left;

      countryDropdownDesktop.style.left = `${centerX}px`;
      countryDropdownDesktop.style.right = "auto";
    }

    if (languageDropdownBtnDesktop && translationDropdownDesktop) {
      const btnRect = languageDropdownBtnDesktop.getBoundingClientRect();
      const dropdownWidth = translationDropdownDesktop.offsetWidth;
      const centerX =
        btnRect.left + btnRect.width / 2 - dropdownWidth / 2 - navbarRect.left;

      translationDropdownDesktop.style.left = `${centerX}px`;
      translationDropdownDesktop.style.right = "auto";
    }
  }

  alignDesktopDropdowns();
  window.addEventListener("resize", alignDesktopDropdowns);
  window.addEventListener("scroll", alignDesktopDropdowns);
});
